export const comments_3899726 = {"data":{"data":[],"links":{}}}